// App shell: fixed sidebar + main content outlet. Replaces the Next app's
// layout.tsx + NavWrapper.tsx + Nav.tsx (the /login + /auth split is handled at
// the router level now, so there's no isAuth branch here).
import { Link, useLocation, Outlet } from "react-router-dom";
import { NAV } from "../lib/nav";
import { supabase } from "../lib/supabase";
import ErrorBoundary from "./ErrorBoundary";

export default function Layout() {
  const { pathname } = useLocation();

  async function signOut() {
    await supabase.auth.signOut();
    // Hard redirect so all in-memory state is cleared; the guard then bounces to
    // /login.
    window.location.href = "/login";
  }

  return (
    <div className="flex min-h-screen">
      <aside className="w-52 shrink-0 border-r border-zinc-800 bg-zinc-950 p-4">
        <div className="mb-6 px-2">
          <div className="text-sm font-semibold text-zinc-100">Surround</div>
          <div className="text-xs text-zinc-500">admin</div>
        </div>
        <nav className="flex flex-col gap-1">
          {NAV.map((i) => {
            const active =
              pathname === i.href || pathname.startsWith(i.href + "/");
            return (
              <Link
                key={i.href}
                to={i.href}
                className={`rounded px-2 py-1.5 text-sm ${
                  active
                    ? "bg-zinc-800 text-white"
                    : "text-zinc-300 hover:bg-zinc-800 hover:text-white"
                }`}
              >
                {i.label}
              </Link>
            );
          })}
        </nav>
        <button
          onClick={signOut}
          className="mt-6 w-full rounded px-2 py-1.5 text-left text-sm text-zinc-500 hover:bg-zinc-800 hover:text-zinc-300"
        >
          Sign out
        </button>
      </aside>
      <main className="flex-1 p-6">
        {/* A render throw in a page shows a recoverable card here — the sidebar
            stays alive. resetKey clears the error on navigation (ADM-2). */}
        <ErrorBoundary resetKey={pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
